export default function ValidationError({
  error,
  show,
  style,
}: {
  error?: string;
  show?: boolean;
  style?: React.CSSProperties | undefined;
}) {
  if (!show || !error) return null;
  return (
    <span style={style} className="invalid-tooltip">
      {error}
    </span>
  );
}
